import { Grid, Box, Typography, Avatar, Stack } from "@mui/material";
import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtPWD from "./CustomTool/CtTxtPWD";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import { TextField, InputAdornment, Tooltip } from "@mui/material";

import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";

import { withRouter } from "../HOC/withRouter";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";
import { fetchCIDetail } from "./API";
export class Subscription extends Component {
  state = {
    formData: {
      // txtCI: "5959",
      // txtProductKey: "9QE3B1J0271828C2B0R0",
      // txtlicensed: "RaviTechWorld",
      // txtfromdate: "04-Dec-2023",
      // txttodate: "04-July-2025",
      txtCI: this.props.CI_Type,
      txtProductKey: this.props.ProductKey,
      txtlicensed: this.props.CI_Name,
      txtfromdate: this.props.FormDate,
      txttodate: this.props.DueDate,
    },
    Days_Sub: this.props.Days,
    showTermsDialog: false,
    isAgreementChecked: false,
    copied: false,
  };

  componentDidMount() {
    document.title = "Account Software : Subscription";
  }

  handleCopy = () => {
    navigator.clipboard
      .writeText(this.state.formData.txtProductKey)
      .then(() => {
        this.setState({ copied: true });
        setTimeout(() => this.setState({ copied: false }), 3000); // 3 seconds
      });
  };

  handleAgreementChange = (event) => {
    const isChecked = event.target.checked;
    this.setState({
      isAgreementChecked: isChecked,
      showTermsDialog: isChecked,
    });
  };

  handleCloseTermsDialog = () => {
    this.setState({ showTermsDialog: false });
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  };

  stringAvatar = (name) => {
    const nameParts = name?.trim().split(" ") || [];
    const firstInitial = nameParts[0]?.[0] || "";
    const secondInitial = nameParts[1]?.[0] || "";
    return {
      sx: { bgcolor: this.stringToColor(name || "U") },
      children: `${firstInitial}${secondInitial}`,
    };
  };

  render() {
    return (
      <div>
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar {...this.stringAvatar(localStorage.getItem("UserName"))} />
          <Stack direction={"column"}>
            <Typography variant="h6" fontWeight="bold">
              Subscription Details
            </Typography>
            {this.props.Days <= 0 ? (
              <>
                <Typography style={{ fontSize: "16px" }}>
                  Subscription Details
                </Typography>
              </>
            ) : (
              <>
                <Typography style={{ fontSize: "16px" }}>
                  License expires in {this.props.Days} days
                </Typography>
              </>
            )}
          </Stack>
        </Box>
        {/* <Box
          marginTop={2}
          sx={{
            backgroundColor: "#f5f5f5",
            paddingX: 3,
            paddingY: 2,
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12} md={6}>
              <CtTxt
                id="txtlicensed"
                label="Licensed To"
                variant="outlined"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txtlicensed}
                width={260}
                onKeyDown={this.props.onKeyDown}
                maxLength="100"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CtTxt
                id="txtCI"
                label="CI Type"
                variant="outlined"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txtCI}
                width={260}
                onKeyDown={this.props.onKeyDown}
                maxLength="100"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CtTxt
                id="txtProductKey"
                label="Subscription Key"
                variant="outlined"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txtProductKey}
                width={260}
                onKeyDown={this.props.onKeyDown}
                maxLength="100"
                showCopyIcon={true}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CtTxt
                id="txtfromdate"
                label="Licensed From Date"
                variant="outlined"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txtfromdate}
                width={260}
                onKeyDown={this.props.onKeyDown}
                maxLength="100"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CtTxt
                id="txttodate"
                label="Licensed Due Date"
                variant="outlined"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txttodate}
                width={260}
                onKeyDown={this.props.onKeyDown}
                maxLength="100"
              />
            </Grid>
            <Typography marginTop={2} variant="h8" style={{ color: "red" }}>
              Subscription Agreement
            </Typography>
            <Grid item xs={12} md={6}>
              <CtBtn
                id="btnOtpSend"
                label="Upgrade"
                bgColor={"#05699d"}
                onClick={this.Sign_Up}
              />
            </Grid>
          </Grid>
        </Box> */}
        <Box
          marginTop={2}
          sx={{
            backgroundColor: "#f5f5f5",
            paddingX: 3,
            paddingY: 2,
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Grid container>
                <Grid item width={160}>
                  <Typography fontWeight="bold">Licensed To</Typography>
                </Grid>
                <Grid item>
                  <Typography>: {this.state.formData.txtlicensed}</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container>
                <Grid item width={160}>
                  <Typography fontWeight="bold">CI Type</Typography>
                </Grid>
                <Grid item>
                  <Typography>: {this.state.formData.txtCI}</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container alignItems="center">
                <Grid item width={160}>
                  <Typography fontWeight="bold">Subscription Key</Typography>
                </Grid>
                <Grid item>
                  <Typography>: {this.state.formData.txtProductKey}</Typography>
                </Grid>
                <Grid item>
                  <Tooltip title={this.state.copied ? "Copied!" : "Copy"}>
                    <IconButton
                      size="small"
                      sx={{ ml: 1 }}
                      onClick={this.handleCopy}
                    >
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container>
                <Grid item width={160}>
                  <Typography fontWeight="bold">Licensed From Date</Typography>
                </Grid>
                <Grid item>
                  <Typography>: {this.state.formData.txtfromdate}</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container>
                <Grid item width={160}>
                  <Typography fontWeight="bold">Licensed Due Date</Typography>
                </Grid>
                <Grid item>
                  <Typography>: {this.state.formData.txttodate}</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item display="flex" alignItems="center">
              <input
                type="checkbox"
                checked={this.state.isAgreementChecked}
                onChange={this.handleAgreementChange}
                // style={{ marginRight: 8 }}
                style={{ margin: "0px", padding: "0px" }}
              />
              <Typography
                variant="subtitle2"
                sx={{ color: "red", marginLeft: "6px", marginTop: "2px" }}
              >
                Subscription Agreement
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent="center">
                <CtBtn
                  id="btnOtpSend"
                  label="Upgrade"
                  bgColor={"#05699d"}
                  onClick={this.Sign_Up}
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HoCtToastContainer(withRouter(Subscription)));
